import {
  toResponseError,
  type DashboardAddInput,
  type DashboardAddSuccess,
  type DashboardDataWithEditable,
  type DashboardListInput,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useDashboardCache } from './cache'

export function useAddDashboard(
  input?: DashboardListInput
): AddHookResponse<DashboardAddInput, DashboardDataWithEditable> {
  const cache = useDashboardCache(input)
  const mutation = useTantalimMutation<DashboardAddInput, DashboardAddSuccess>({ url: '/report/dashboard/add' })

  async function add(input: DashboardAddInput): Promise<DashboardDataWithEditable> {
    try {
      const { dashboard } = await mutation.mutateAsync(input)
      cache.addItem(dashboard)
      return dashboard
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
